export const GET_ETP_LIST = `${BACKOFFICE_API_URL}/etps`
export const GET_ETP_DETAILS = `${BACKOFFICE_API_URL}/etps/:id`
export const FIND_INVESTORS = `${BACKOFFICE_API_URL}/investor`
export const GET_ACCOUNTS = `${BACKOFFICE_API_URL}/accounting/trading-accounts`
export const GET_BALANCES = `${BACKOFFICE_API_URL}/accounting/trading-accounts/:account_id/balance`
export const MANUAL_BID = `${BACKOFFICE_API_URL}/etps/:id/buy-order`
export const CANCEL_ETP = `${GET_ETP_DETAILS}/cancel`
export const DEFAULT_ETP = `${GET_ETP_DETAILS}/default`
export const WRITE_OFF_ETP = `${GET_ETP_DETAILS}/write_off`
